import React, { useEffect, useState } from "react";
import logo from "../images/quizzy_logo.png";

import { nanoid } from "nanoid";

export default function Intro(props) {
  // STATE
  // This state will hold the array of categories retrieved from the OpenTrivia API
  // Looping on this array we will generate the options for the select that output the categories for the quiz
  const [categories, setCategories] = useState([]);

  // Fetching Categories from the API after the first render
  // I need to fetch data only one time, after the app loads, so i use an empty array [] as dependencies
  useEffect(() => {
    // Retrieving the array of categories from the API and setting it as the value of the categories state
    fetch("https://opentdb.com/api_category.php")
      .then(res => res.json())
      .then(data => setCategories(data.trivia_categories));
  }, []);

  return (
    <div className="intro">
      <div className="intro__inner">
        <div className="logo-container">
          <img src={logo} alt="Quizzy logo" className="logo" />
        </div>
        <p>Build your own quiz then have fun answering it!</p>
        <form className="quiz-buildup" onSubmit={props.handleSubmit}>
          <div className="quiz-buildup__option">
            <label htmlFor="amount">
              Number of questions (min 5 - max 50):
            </label>
            <input
              className="textfields"
              type="number"
              min={5}
              max={50}
              value={props.quizOptions.amount}
              id="amount"
              name="amount"
              onChange={props.handleChange}
              required
            />
          </div>
          <div className="quiz-buildup__option">
            <label htmlFor="category">Select the topic:</label>
            <select
              className="textfields"
              id="category"
              name="category"
              value={props.quizOptions.category}
              onChange={props.handleChange}
            >
              <option value="">Any topic</option>
              {
                // Generating the options for the select[name="category"] by looping on the categories state-array that contains all the categories objects fetched from the API
                categories.length > 0 &&
                  categories.map(category => (
                    <option key={nanoid()} value={category.id}>
                      {category.name}
                    </option>
                  ))
              }
            </select>
          </div>
          <div className="quiz-buildup__option">
            <label htmlFor="difficulty">Select difficulty:</label>
            <select
              className="textfields"
              id="difficulty"
              name="difficulty"
              value={props.quizOptions.difficulty}
              onChange={props.handleChange}
            >
              <option value="">Any difficulty</option>
              <option value="easy">Easy</option>
              <option value="medium">Medium</option>
              <option value="hard">Hard</option>
            </select>
          </div>
          <div className="quiz-buildup__option">
            <label htmlFor="type">Select quiz type:</label>
            <select
              className="textfields"
              id="type"
              name="type"
              value={props.quizOptions.type}
              onChange={props.handleChange}
            >
              <option value="">Any type</option>
              <option value="multiple">Multiple Choice</option>
              <option value="boolean">True / False</option>
            </select>
          </div>
          <button className="quiz-buildup__btn">Start</button>
        </form>
      </div>
    </div>
  );
}
